import React, { ReactNode, SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { CaratDown } from '@weee-fe/kunlunicon';

import { OnClickFunctionType } from '@/types/common-dom/types';

type ComponentProps = {
  label: string | ReactNode;
  onClick?: OnClickFunctionType;
  mainColorTwNotation?: string /* Example: text-surface-100-fg-minor PS: string interpolation won't work */;
  mainIcon?:
    | SVGProps<SVGSVGElement>
    | ReactNode /* Example, on the parent of this Dummy UI component, you import your "kunlunicon" */;
  hideCarat?: boolean;
  caratSize?: number;
  wrapperClassName?: string;
  dataTestId?: string;
};

export const defaultIconSize = 12;

const DropDownStatic = (props: ComponentProps) => {
  const {
    label,
    mainColorTwNotation = 'text-surface-100-fg-minor',
    hideCarat = false,
    caratSize = defaultIconSize,
    wrapperClassName = '',
    dataTestId = ''
  } = props;

  const activePillEffect =
    `relative active:before:content-[""] before:z-[1] before:absolute before:rounded-500 before:left-[calc(theme(spacing.200)_*_-1)] before:w-[calc(100%_+_theme(spacing.400))] before:h-[calc(100%_+_theme(spacing.200))] before:bg-[rgb(240_240_240_/_80%)]` +
    (props?.mainIcon ? ' before:left-[-10px]' : '');

  return (
    <div
      className={twMerge('flex shrink-0 gap-50 items-center', activePillEffect, wrapperClassName)}
      data-testid={dataTestId}
      onClick={props?.onClick || null}>
      <div className="flex items-center gap-200 z-[2]">
        {props?.mainIcon}
        <span className={twMerge('font-normal', mainColorTwNotation)}>{label}</span>
      </div>
      {!hideCarat && (
        <CaratDown width={caratSize} height={caratSize} className={twMerge('z-[2]', mainColorTwNotation)} />
      )}
    </div>
  );
};

export default React.memo(DropDownStatic);
